import { notFound } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";

/**
 * Throws TanStack `notFound()` (served with HTTP 404) when a published row
 * with this slug definitely does not exist. Previously missing pages rendered
 * a "not found" message with HTTP 200, which Google reports as "Soft 404".
 * Network/query errors fall through so real pages are never 404'd by mistake.
 */
export async function ensureExists(
  table: string,
  slug: string,
  extra: Record<string, string> = {},
  statusFilter = true,
) {
  if (!slug) throw notFound();
  try {
    let q = (supabase as any).from(table).select("slug").eq("slug", slug);
    if (statusFilter) q = q.eq("status", "published");
    for (const [k, v] of Object.entries(extra)) q = q.eq(k, v);
    const { data, error } = await q.limit(1);
    if (error) return;
    if (!data || data.length === 0) throw notFound();
  } catch (e) {
    if ((e as any)?.isNotFound) throw e;
  }
}
